import { useCallback, useState } from 'react';

// useForceUpdate is a React Hook that forces your component to re-render.
const useForceUpdate = () => {
  const [, dispatch] = useState(Object.create(null));

  const memoizedDispatch = useCallback(() => {
    dispatch(Object.create(null));
  }, [dispatch]);
  return memoizedDispatch;
};

export default useForceUpdate;
